import {useState, cloneElement} from 'react';
import useToggle from '../hooks/useToggle';

const useEditModal = ({editComponent, addComponent, onRefresh = () => {}}) => {
	const {isOpen, toggler} = useToggle({
		onClose: onRefresh
	});
	const [body, setBody] = useState(null);

	const addAction = (info) => {
		toggler();
		setBody(cloneElement(addComponent,{info}));
	};

	const editAction = (props) => {
		toggler();
		setBody(cloneElement(editComponent, props));
	};

	const wrapper = {
		show: isOpen,
		onHide: toggler,
		body: body
	};

	return {wrapper, refresh: false, addAction, editAction};
};

export default useEditModal;
